import React, { useState } from 'react';
import { FDWizardModalWrapper } from 'Views/Page/Content/Modal/Layouts/FDWizardModalWrapper';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  AnalyzeYourExpensesChart,
} from 'Views/Page/Content/Modal/Layouts/AnalyzeYourExpensesTemplate/AnalyzeYourExpensesChart';
import {
  AnalyzeYourExpensesQuestion,
} from 'Views/Page/Content/Modal/Layouts/AnalyzeYourExpensesTemplate/AnalyzeYourExpensesQuestion';
import { FDAlert } from '@facet-wealth/design';

export const AnalyzeYourExpenses = () => {
  const { resource } = useMetaLayoutContext();
  const [selectedDescription, setSelectedDescription] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);

  function handleLegendOnClick(data) {
    setSelectedDescription(data.payload.description);
    setSelectedValue(data.value);
  }

  function handleChartOnClick(data) {
    setSelectedDescription(data.description);
    setSelectedValue(data.name);
  }

  return (
    <FDWizardModalWrapper resource={resource}>
      <AnalyzeYourExpensesChart resource={resource} onLegendClick={handleLegendOnClick} onChartClick={handleChartOnClick} />
      {selectedDescription && selectedValue && (
        <FDAlert status="info" title={selectedValue} description={selectedDescription} />
      )}
      <AnalyzeYourExpensesQuestion resource={resource} />
    </FDWizardModalWrapper>
  );
};

AnalyzeYourExpenses.defaultProps = {
};

AnalyzeYourExpenses.propTypes = {
};
